export default "__VITE_ASSET__D9rQ2fP4__"